import { ScatterDataPoint } from "chart.js"
import { ChartLegend, ChartLegendItem } from "../ChartLegend/ChartLegend"
import { LineChartComponent, LineChartProps } from "./LineChartComponent"

type Props<TData, TLabel> = {
  chart: LineChartProps<TData, TLabel>
  showLegend?: boolean
  dataTestId?: string
}

export const LineChart = <TData = (number | ScatterDataPoint | null)[], TLabel = unknown>({
  chart,
  showLegend,
  dataTestId,
}: Props<TData, TLabel>) => (
  <div data-testid={dataTestId}>
    {showLegend && (
      <ChartLegend>
        {chart.datasets.map(
          (dataset) =>
            dataset.datasetOptions && (
              <ChartLegendItem
                key={dataset.datasetOptions.legend}
                label={dataset.datasetOptions.legend}
                color={dataset.datasetOptions.borderColor}
              />
            )
        )}
      </ChartLegend>
    )}
    <LineChartComponent<TData, TLabel> {...chart} />
  </div>
)

LineChart.defaultProps = {
  dataTestId: undefined,
  showLegend: false,
}
